import { motion } from "framer-motion";
import SectionLabel from "./SectionLabel";
import { RevealOnScroll } from "./Reveal";

const PILLARS = [
  { n: "I",   name: "Global Supply Network",         body: "Trusted corridors between the world's finest manufacturers and the African continent." },
  { n: "II",  name: "Trusted Manufacturing Partners", body: "Long-standing relationships with the makers we choose — never brokered, always direct." },
  { n: "III", name: "African Market Expertise",       body: "Deep knowledge of the ports, roads, climate and clientele we serve." },
  { n: "IV",  name: "Premium Customer Experience",    body: "A single point of contact from first enquiry to delivery and beyond." },
];

export default function Pillars() {
  return (
    <section data-testid="pillars-section" className="section-y bg-navy border-t border-white/5">
      <div className="container-editorial">
        <div className="grid grid-cols-12 gap-8 md:gap-16 mb-20 md:mb-28">
          <div className="col-span-12 md:col-span-5">
            <motion.span
              initial={{ scaleX: 0 }} whileInView={{ scaleX: 1 }}
              viewport={{ once: true, amount: 0.6 }}
              transition={{ duration: 1.2, ease: [0.19, 1, 0.22, 1] }}
              className="block h-px bg-[#C5A059] w-14 mb-8 origin-left"
            />
            <div className="overline text-[#C5A059] mb-6">The Foundations</div>
            <RevealOnScroll
              element="h2"
              className="font-display text-5xl md:text-6xl leading-[0.95] tracking-tight"
              lines={["Four commitments,", "<em>held quietly</em>."]}
            />
          </div>
          <div className="col-span-12 md:col-span-6 md:col-start-7 md:pt-6">
            <p className="editorial-body max-w-md">
              The Maklan standard rests on four quiet foundations. Each is
              non-negotiable. Each is applied to every division we open.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-16 gap-y-14 md:gap-y-20">
          {PILLARS.map((p, i) => (
            <motion.div
              key={p.name}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.35 }}
              transition={{ duration: 1.2, delay: i * 0.08, ease: [0.19, 1, 0.22, 1] }}
              className="pb-10 border-b border-white/10"
              data-testid={`pillar-${i}`}
            >
              <div className="text-[#C5A059] font-display italic text-3xl md:text-4xl mb-6 leading-none">
                {p.n}
              </div>
              <h3 className="font-display text-2xl md:text-3xl mt-4 mb-4 leading-tight">{p.name}</h3>
              <p className="editorial-body max-w-md">{p.body}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
